import React, { useState } from 'react';
import { Button, TextField, IconButton, Grid, Typography, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Delete, Add, Edit } from '@mui/icons-material';
import '../../../../styles/WineForm.scss';

const WineFormGroup = ({ cantina, wines, setWines }) => {
  const [newWine, setNewWine] = useState({ name: '', description: '', price: '' });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingWineIndex, setEditingWineIndex] = useState(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [wineToDeleteIndex, setWineToDeleteIndex] = useState(null);

  const handleDialogOpen = (wine = { name: '', description: '', price: '' }, index = null) => {
    setNewWine(wine);
    setEditingWineIndex(index);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setNewWine({ name: '', description: '', price: '' });
    setEditingWineIndex(null);
    setDialogOpen(false);
  };

  const handleAddOrUpdateWine = () => {
    if (editingWineIndex !== null) {
      const updatedWines = wines.map((wine, index) => (index === editingWineIndex ? newWine : wine));
      setWines(updatedWines);
    } else {
      setWines([...wines, newWine]);
    }
    handleDialogClose();
  };

  const handleOpenConfirmDelete = (index) => {
    setWineToDeleteIndex(index);
    setConfirmDeleteOpen(true);
  };

  const handleConfirmDeleteClose = () => {
    setWineToDeleteIndex(null);
    setConfirmDeleteOpen(false);
  };

  const handleDeleteWine = () => {
    const updatedWines = wines.filter((_, i) => i !== wineToDeleteIndex);
    setWines(updatedWines);
    handleConfirmDeleteClose();
  };

  return (
    <div className='wine-form-group'>
      {/* <Typography variant="h6">Lista dei vini:</Typography> */}
      <Grid container spacing={2}>
        {wines.map((wine, index) => (
          <Grid item xs={12} key={index}>
            <div className='wine-edit-item'>
              <Typography>{wine.name}</Typography>
              <div className='wine-edit-item'>
                <IconButton onClick={() => handleDialogOpen(wine, index)}>
                  <Edit />
                </IconButton>
                <IconButton onClick={() => handleOpenConfirmDelete(index)}>
                  <Delete />
                </IconButton>
              </div>
            </div>
          </Grid>
        ))}
      </Grid>
      <div className='add-btn-container'>
        <Button onClick={() => handleDialogOpen()} variant="contained" startIcon={<Add />} className='add-btn'>
          Aggiungi Vino
        </Button>
      </div>

      {/* Dialog per aggiungere/modificare il vino */}
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle>{editingWineIndex !== null ? 'Modifica Vino' : 'Aggiungi Vino'}</DialogTitle>
        <DialogContent>
          <TextField
            label="Nome Vino"
            fullWidth
            value={newWine.name}
            onChange={(e) => setNewWine({ ...newWine, name: e.target.value })}
            margin="normal"
          />
          <TextField
            label="Prezzo"
            fullWidth
            value={newWine.price}
            onChange={(e) => setNewWine({ ...newWine, price: e.target.value })}
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddOrUpdateWine} variant="contained">
            {editingWineIndex !== null ? 'Aggiorna' : 'Aggiungi'}
          </Button>
          <Button onClick={handleDialogClose} color="secondary">Annulla</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog di conferma per la cancellazione */}
      <Dialog open={confirmDeleteOpen} onClose={handleConfirmDeleteClose}>
        <DialogTitle>Conferma Eliminazione</DialogTitle>
        <DialogContent>
          <Typography>Sei sicuro di voler eliminare questo vino?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteWine} color="error" variant="contained">
            Elimina
          </Button>
          <Button onClick={handleConfirmDeleteClose} color="secondary">Annulla</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default WineFormGroup;
